export const scrollToComprar = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()
  const element = document.getElementById('comprar')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

export const CHECKOUT_URL =
  'https://checkout.ebookbtnlines.shop/cart/45362493390895:1'

export const openCheckout = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()
  window.open(CHECKOUT_URL, '_blank')
}
